import { createContext } from "react";

const AsesorChargeContext = createContext();

export default AsesorChargeContext;
